import React, { Component } from 'react';
import Circle from '../circle';
var topLoader;
export default class Apoyo extends Component {
  componentDidMount() {
    window.addEventListener('DOMContentLoaded', () => {
      topLoader = new Circle(document.getElementById('topLoader'), {
        controllable: false,
        progress: 0.5
      });
      topLoader.loaded(() => {
        topLoader.setProgress(parseFloat(0));
      });
    });
    var addScript = document.createElement('script');
    addScript.setAttribute('src', '/js/jquery.percentageloader-0.2.js');
    document.body.appendChild(addScript);
  }

  componentWillReceiveProps(nextprops) {
    this.sistema(parseInt(nextprops.value, 10));
  }

  sistema(valor) {
    topLoader = new Circle(document.getElementById('topLoader'), {
      controllable: false,
      progress: 0.5
    });
    let valueProgress = 0;
    if (parseInt(valor, 10) >= 11) {
      let ran = [0.75, 0.79, 0.8, 0.84, 0.88, 0.9, 0.92, 0.94, 0.96, 0.98, 1];
      valueProgress = ran[Math.floor(Math.random() * ran.length)];
    } else if (parseInt(valor, 10) >= 6 && parseInt(valor, 10) <= 10) {
      let ran = [0.4, 0.45, 0.49, 0.5, 0.55, 0.58, 0.6];
      valueProgress = ran[Math.floor(Math.random() * ran.length)];
    } else if (parseInt(valor, 10) >= 1 && parseInt(valor, 10) <= 5) {
      let ran = [0.1, 0.15, 0.2, 0.22, 0.23, 0.25, 0.33, 0.35];
      valueProgress = ran[Math.floor(Math.random() * ran.length)];
    }
    topLoader.loaded(() => {
      topLoader.setProgress(parseFloat(valueProgress));
    });
  }

  pruebaexport(el, params) {
    var imageLoaded = false;
    /* Our spiral gradient data */
    var imgdata = '',
      gradient = new Image();

    gradient.src = imgdata;
    gradient.addEventListener('load', function() {
      imageLoaded = true;
    });

    window.PercentageLoader = function(el, params) {
      var settings,
        canvas,
        percentageText,
        valueText,
        items,
        i,
        item,
        selectors,
        s,
        ctx,
        progress,
        value,
        cX,
        cY,
        lingrad,
        innerGrad,
        tubeGrad,
        innerRadius,
        innerBarRadius,
        outerBarRadius,
        radius,
        startAngle,
        endAngle,
        counterClockwise,
        completeAngle,
        setProgress,
        setValue,
        applyAngle,
        drawLoader,
        clipValue,
        outerDiv,
        ready,
        plugin;

      plugin = this;

      /* Specify default settings */
      settings = {
        width: 256,
        height: 256,
        progress: 0,
        value: '0kb',
        controllable: false
      };

      /* Override default settings with provided params, if any */
      if (params !== undefined) {
        var prop;
        for (prop in settings) {
          if (settings.hasOwnProperty(prop) && !params.hasOwnProperty(prop)) {
            params[prop] = settings[prop];
          }
        }
      } else {
        params = settings;
      }

      outerDiv = document.createElement('div');
      outerDiv.style.width = settings.width + 'px';
      outerDiv.style.height = settings.height + 'px';
      outerDiv.style.position = 'relative';

      el.appendChild(outerDiv);

      /* Create our canvas object */
      canvas = document.createElement('canvas');
      canvas.setAttribute('width', settings.width);
      canvas.setAttribute('height', settings.height);
      outerDiv.appendChild(canvas);

      /* Create div elements we'll use for text. Drawing text is
         * possible with canvas but it is tricky working with custom
         * fonts as it is hard to guarantee when they become available
         * with differences between browsers. DOM is a safer bet here */
      percentageText = document.createElement('div');
      percentageText.style.width = settings.width.toString() - 2 + 'px';
      percentageText.style.textAlign = 'center';
      percentageText.style.height = '50px';
      percentageText.style.left = 0;
      percentageText.style.position = 'absolute';

      valueText = document.createElement('div');
      valueText.style.width = (settings.width - 2).toString() + 'px';
      valueText.style.textAlign = 'center';
      valueText.style.height = '0px';
      valueText.style.overflow = 'hidden';
      valueText.style.left = 0;
      valueText.style.position = 'absolute';

      /* Force text items to not allow selection */
      items = [valueText, percentageText];
      for (i = 0; i < items.length; i += 1) {
        item = items[i];
        selectors = [
          '-webkit-user-select',
          '-khtml-user-select',
          '-moz-user-select',
          '-o-user-select',
          'user-select'
        ];

        for (s = 0; s < selectors.length; s += 1) {
          item.style[selectors[s]] = 'none';
        }
      }

      /* Add the new dom elements to the containing div */
      outerDiv.appendChild(percentageText);
      outerDiv.appendChild(valueText);

      /* Get a reference to the context of our canvas object */
      ctx = canvas.getContext('2d');

      /* Set various initial values */

      /* Centre point */
      cX = canvas.width / 2 - 1;
      cY = canvas.height / 2 - 1;

      /* Create our linear gradient for the outer ring */
      lingrad = ctx.createLinearGradient(cX, 0, cX, canvas.height);
      lingrad.addColorStop(0, '#10638B');
      lingrad.addColorStop(1, '#10638B');

      /* Create inner gradient for the outer ring */
      innerGrad = ctx.createLinearGradient(
        cX,
        cX * 0.133333,
        cX,
        canvas.height - cX * 0.133333
      );
      innerGrad.addColorStop(0, '#10638B');
      innerGrad.addColorStop(1, '#10638B');

      /* Tube gradient (background, not the spiral gradient) */
      tubeGrad = ctx.createLinearGradient(cX, 0, cX, canvas.height);
      tubeGrad.addColorStop(0, '#10638B');
      tubeGrad.addColorStop(1, '#10638B');

      /* The inner circle is 2/3rds the size of the outer one */
      innerRadius = cX * 0.6666;
      /* Outer radius is the same as the width / 2, same as the centre x
        * (but we leave a little room so the borders aren't truncated) */
      radius = cX - 2;

      /* Calculate the radii of the inner tube */
      innerBarRadius = innerRadius + cX * 0.06;
      outerBarRadius = radius - cX * 0.06;

      /* Bottom left angle */
      startAngle = 2.1707963267949;
      /* Bottom right angle */
      endAngle = 0.9707963267949 + Math.PI * 2.0;

      /* Nicer to pass counterClockwise / clockwise into canvas functions
        * than true / false */
      counterClockwise = false;

      /* Borders should be 1px */
      ctx.lineWidth = 1;

      /**
       * Little helper method for transforming points on a given
       * angle and distance for code clarity
       */
      applyAngle = function(point, angle, distance) {
        return {
          x: point.x + Math.cos(angle) * distance,
          y: point.y + Math.sin(angle) * distance
        };
      };

      /**
       * render the widget in its entirety.
       */
      drawLoader = function() {
        /* Clear canvas entirely */
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        /*** IMAGERY ***/

        /* draw outer circle */
        ctx.fillStyle = lingrad;
        ctx.beginPath();
        ctx.strokeStyle = '#10638B';
        ctx.arc(cX, cY, radius, 0, Math.PI * 2, counterClockwise);
        ctx.fill();
        ctx.stroke();

        /* draw inner circle */
        ctx.fillStyle = innerGrad;
        ctx.beginPath();
        ctx.arc(cX, cY, innerRadius, 0, Math.PI * 2, counterClockwise);
        ctx.fill();
        ctx.strokeStyle = '#10638B';
        ctx.stroke();

        ctx.beginPath();

        /**
         * Helper function - adds a path (without calls to beginPath or closePath)
         * to the context which describes the inner tube. We use this for drawing
         * the background of the inner tube (which is always at 100%) and the
         * progress meter itself, which may vary from 0-100% */
        function makeInnerTubePath(startAngle, endAngle) {
          var centrePoint,
            startPoint,
            controlAngle,
            capLength,
            c1,
            c2,
            point1,
            point2;
          centrePoint = {
            x: cX,
            y: cY
          };

          startPoint = applyAngle(centrePoint, startAngle, innerBarRadius);

          ctx.moveTo(startPoint.x, startPoint.y);

          point1 = applyAngle(centrePoint, endAngle, innerBarRadius);
          point2 = applyAngle(centrePoint, endAngle, outerBarRadius);

          controlAngle = endAngle + 3.142 / 2.0;
          /* Cap length - a fifth of the canvas size minus 4 pixels */
          capLength = cX * 0.2 - 4;

          c1 = applyAngle(point1, controlAngle, capLength);
          c2 = applyAngle(point2, controlAngle, capLength);

          ctx.arc(cX, cY, innerBarRadius, startAngle, endAngle, false);
          ctx.bezierCurveTo(c1.x, c1.y, c2.x, c2.y, point2.x, point2.y);
          ctx.arc(cX, cY, outerBarRadius, endAngle, startAngle, true);

          point1 = applyAngle(centrePoint, startAngle, innerBarRadius);
          point2 = applyAngle(centrePoint, startAngle, outerBarRadius);

          controlAngle = startAngle - 3.142 / 2.0;

          c1 = applyAngle(point2, controlAngle, capLength);
          c2 = applyAngle(point1, controlAngle, capLength);

          ctx.bezierCurveTo(c1.x, c1.y, c2.x, c2.y, point1.x, point1.y);
        }

        /* Background tube */
        ctx.beginPath();
        ctx.strokeStyle = '#10638B';
        makeInnerTubePath(startAngle, endAngle);

        ctx.fillStyle = tubeGrad;
        ctx.fill();
        ctx.stroke();

        /* Calculate angles for the the progress metre */
        completeAngle = startAngle + progress * (endAngle - startAngle);

        ctx.beginPath();
        makeInnerTubePath(startAngle, completeAngle);

        /* We're going to apply a clip so save the current state */
        ctx.save();
        /* Clip so we can apply the image gradient */
        ctx.clip();

        /* Draw the spiral gradient over the clipped area */
        ctx.drawImage(gradient, 0, 0, canvas.width, canvas.height);

        /* Undo the clip */
        ctx.restore();

        /* Draw the outline of the path */
        ctx.beginPath();
        makeInnerTubePath(startAngle, completeAngle);
        ctx.stroke();

        /*** TEXT ***/
        (function() {
          var fontSize, string, smallSize, heightRemaining;
          /* Calculate the size of the font based on the canvas size */
          fontSize = cX / 2;

          percentageText.style.top =
            (settings.height / 2 - fontSize / 2).toString() + 'px';
          percentageText.style.color = '#10638B';
          percentageText.style.font =
            fontSize.toString() + 'px BebasNeueRegular';
          percentageText.style.textShadow = '0 1px 1px #10638B';

          /* Calculate the text for the given percentage */
          string = (progress * 100.0).toFixed(0) + '%';

          percentageText.innerHTML = string;

          /* Calculate font and placement of small 'value' text */
          smallSize = cX / 5.5;
          valueText.style.color = '#10638B';
          valueText.style.font = smallSize.toString() + 'px BebasNeueRegular';
          valueText.style.height = smallSize.toString() + 'px';
          valueText.style.textShadow = 'None';

          /* Ugly vertical align calculations - fit into bottom ring.
                 * The bottom ring occupes 1/6 of the diameter of the circle */
          heightRemaining = settings.height * 0.16666666 - smallSize;
          valueText.style.top =
            (settings.height * 0.8333333 + heightRemaining / 4).toString() +
            'px';
        })();
      };

      /**
       * Check the progress value and ensure it is within the correct bounds [0..1]
       */
      clipValue = function() {
        if (progress < 0) {
          progress = 0;
        }

        if (progress > 1.0) {
          progress = 1.0;
        }
      };

      /* Sets the current progress level of the loader
         *
         * @param value the progress value, from 0 to 1. Values outside this range
         * will be clipped
         */
      setProgress = function(value) {
        /* Clip values to the range [0..1] */
        progress = value;
        clipValue();
        drawLoader();
      };

      this.setProgress = setProgress;

      setValue = function(val) {
        value = val;
        valueText.innerHTML = value;
      };

      ready = function(fn) {
        if (imageLoaded) {
          fn();
        } else {
          gradient.addEventListener('load', fn);
        }
      };

      this.setValue = setValue;
      this.setValue(settings.value);

      this.loaded = ready;

      progress = settings.progress;
      clipValue();

      /* Do an initial draw */
      drawLoader();

      /* In controllable mode, add event handlers */
      if (params.controllable === true) {
        (function() {
          var mouseDown, getDistance, adjustProgressWithXY;
          getDistance = function(x, y) {
            return Math.sqrt(Math.pow(x - cX, 2) + Math.pow(y - cY, 2));
          };

          mouseDown = false;

          adjustProgressWithXY = function(x, y) {
            /* within the bar, calculate angle of touch point */
            var pX, pY, angle, startTouchAngle, range, posValue;
            pX = x - cX;
            pY = y - cY;

            angle = Math.atan2(pY, pX);
            if (angle > Math.PI / 2.0) {
              angle -= Math.PI * 2.0;
            }

            startTouchAngle = startAngle - Math.PI * 2.0;
            range = endAngle - startAngle;
            posValue = (angle - startTouchAngle) / range;
            setProgress(posValue);

            if (params.onProgressUpdate !== undefined) {
              /* use the progress value as this will have been clipped
                         * to the correct range [0..1] after the call to setProgress
                         */
              params.onProgressUpdate.call(plugin, progress);
            }
          };

          outerDiv.addEventListener('mousedown', function(e) {
            var offset, x, y, distance;
            offset = this.getBoundingClientRect();
            x = e.pageX - offset.left;
            y = e.pageY - offset.top;

            distance = getDistance(x, y);

            if (distance > innerRadius && distance < radius) {
              mouseDown = true;
              adjustProgressWithXY(x, y);
            }
          });

          outerDiv.addEventListener('mouseup', function() {
            mouseDown = false;
          });

          outerDiv.addEventListener('mousemove', function(e) {
            var offset, x, y;
            if (mouseDown) {
              offset = this.getBoundingClientRect();
              x = e.pageX - offset.left;
              y = e.pageY - offset.top;
              adjustProgressWithXY(x, y);
            }
          });

          outerDiv.addEventListener('mouseleave', function(e) {
            mouseDown = false;
          });
        })();
      }

      return this;
    };
  }
  render() {
    return (
      <div>
        <div id="topLoader" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/survey/circles/Apoyo.jsx